/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_Archive_ConfirmInputs */

const cs_pipelines_archive_confirm = /** @type {(inputs: Pipelines_Archive_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivovat tuto pipeline? Půjde znovu aktivovat jen přes administraci.`)
};

const en_pipelines_archive_confirm = /** @type {(inputs: Pipelines_Archive_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive this pipeline? It can only be reactivated via admin tooling.`)
};

/**
* | output |
* | --- |
* | "Archive this pipeline? It can only be reactivated via admin tooling." |
*
* @param {Pipelines_Archive_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_archive_confirm = /** @type {((inputs?: Pipelines_Archive_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_Archive_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_archive_confirm(inputs)
	return cs_pipelines_archive_confirm(inputs)
});